import { Link } from "react-router-dom";
import { AppHeader, SourceNote } from "@/components/Layout";
import { useSeo } from "@/lib/seo";

export const LEGAL = {
  entity: "Seamless Apps",
  abn: "81 276 904 591",
  email: "hello@seamless-apps.com",
  jurisdiction: "Victoria, Australia",
  updated: "1 June 2026",
  version: "2026-06-01",
};

export const Section = ({ n, title, children }) => (
  <section className="mt-10" data-testid={`legal-section-${n}`}>
    <h2 className="font-display text-lg font-semibold tracking-tight text-slate-900 md:text-lg">
      {n}. {title}
    </h2>
    <div className="mt-3 space-y-3 text-sm text-slate-600 md:text-base">{children}</div>
  </section>
);

export const LegalLayout = ({ title, intro, testid, seoTitle, seoDescription, path, children }) => {
  useSeo({ title: seoTitle || title, description: seoDescription || intro, path });
  return (
  <div className="min-h-screen bg-white">
    <AppHeader />
    <div className="mx-auto max-w-3xl px-5 py-10 sm:py-20" data-testid={testid}>
      <p className="label-caps text-slate-400">Legal</p>
      <h1 className="mt-3 font-display text-4xl font-bold tracking-tighter text-slate-900 sm:text-5xl">
        {title}
      </h1>
      <p className="mt-5 text-base text-slate-600">{intro}</p>
      <p className="mt-6 rounded-2xl bg-slate-50 p-5 text-sm text-slate-600" data-testid="legal-entity">
        {LEGAL.entity} (ABN {LEGAL.abn}) operates Food Recall Alerts at foodrecallalerts.com.au.
        Contact us any time at{" "}
        <a href={`mailto:${LEGAL.email}`} className="font-medium text-slate-900 underline">
          {LEGAL.email}
        </a>
        .<br />
        <span className="text-slate-400">Last updated {LEGAL.updated}</span>
      </p>
      {children}
      <div className="mt-14 flex flex-wrap gap-x-5 gap-y-2 border-t border-slate-100 pt-6 text-sm text-slate-500">
        <Link to="/terms" data-testid="legal-terms-link" className="hover:text-slate-900">Terms of Service</Link>
        <Link to="/privacy" data-testid="legal-privacy-link" className="hover:text-slate-900">Privacy Policy</Link>
        <Link to="/pricing" className="hover:text-slate-900">Pricing</Link>
        <Link to="/" className="hover:text-slate-900">Home</Link>
      </div>
      <div className="mt-8">
        <SourceNote />
      </div>
    </div>
  </div>
  );
};
